import { KeyedResource } from './keyed.resource';

export class ActionResource extends KeyedResource {
  private actionNameImpl: string;

  constructor(args: any) {
    super(args, args.actionName);

    const self: any = this;

    self.resourceType = 'action';
    self.actionNameImpl = this.uiResourceName;
  }

  public get actionName() {
    return this.actionNameImpl;
  }
}
